import { NAME } from './constants';
import { menu } from './menu';
import { router } from './router';

export const Accounting = {
	name: NAME,
	menu,
	router,
};
